import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=226911b4&scoped=true&"
import script from "./designer.vue?vue&type=script&lang=js&"
export * from "./designer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226911b4",
  null
  
)

export default component.exports